"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRouter = withRouter;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 *
 * withRouter from react-router v3 has been deprecated in react-router-dom v6. This is a replacement that does
 * not involve refactoring React class components into functional components. If your react component is a functional component,
 * it's better to use the hooks directly than to use this HOC, keep that in mind.
 */
function withRouter(Child) {
  return function (props) {
    var location = (0, _reactRouterDom.useLocation)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var params = (0, _reactRouterDom.useParams)();
    return /*#__PURE__*/_react.default.createElement(Child, _extends({}, props, {
      navigate: navigate,
      location: location,
      params: params
    }));
  };
}